import { useQuery } from 'react-query';

import { ISelectModel } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getObjectsCities } from 'services/api/apiCalls/rentals';

const getCities = (): Promise<ISelectModel<number>[]> =>
  getObjectsCities().then(response => response.data);

export const useAccommodationCitiesQuery = () =>
  useQuery(QUERY_KEYS.RENTALS_OBJECT_CITIES, getCities);
